<template>
  <div>

    <v-dialog persistent v-if="dialogyetki" v-model="dialogyetki" max-width="900px">
      <v-card color="grey lighten-5">

        <v-flex pa-1 xs12 sm12 md12>
          <v-layout row wrap>
            <v-flex pr-3 pt-3 xs12 sm12>
              <div class="scrollbar" id="style-1">
                <v-card color="white" flat>
                  <v-flex pl-3 pr-3 pt-3 xs12 sm12>

                    <div class="force-overflow">
                      <p><strong>KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ BİLGİLENDİRME YAZISI</strong></p>
                      <p>ARKMAN olarak kişisel verilerinizin güvenliği, şirketimizin öncelikleri arasındadır.
                        &nbsp;Kişisel verilerin işlenmesinde kişilerin temel hak ve özgürlüklerini korumak ve kişisel
                        verilerin korunması amacıyla düzenlenen Kişisel Verilerin Korunması Kanunu ( KVKK ) ve kişisel
                        verilerinizin işlenmesi uygulamalarımız ile ilgili bu bilgilendirmeyi sizlerle paylaşmaktan
                        memnuniyet duyarız.&nbsp;</p>
                      <p><strong>KİŞİSEL VERİ TANIMI&nbsp;</strong></p>
                      <p>KVKK ‘da Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü
                        bilgiyi; &nbsp;kişisel verilerin işlenmesi, kişisel verilerin tamamen veya kısmen otomatik olan
                        ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde
                        edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi,
                        açıklanması, aktarılması, devralınması, elde edilebilir hâle getirilmesi, sınıflandırılması ya
                        da kullanılmasının engellenmesi gibi veriler üzerinde gerçekleştirilen her türlü işlemi ifade
                        etmektedir.</p>
                      <p><strong>KİŞİSEL VERİLERİN İŞLENME AMAÇLARI&nbsp;</strong></p>
                      <p>KVKK ve diğer yasal mevzuattan kaynaklanan yasal yükümlülüklerimiz çerçevesinde,
                        gizliliklerinin korunması için gereken tedbirler alınmak üzere; alışveriş, iletişim ve diğer her
                        türlü kişisel olan/ olmayan bilginiz, ARKMAN, tarafından sunulan ürün ve hizmetlerimizden
                        sorunsuz olarak yararlanabilmek, alınan bilgiler ile ürün çeşitliliğimizi geliştirebilmek
                        beğeninize göre ürün çeşitliliği sağlamak, yukarıda tanımı yapılan bilgileriniz alınarak sizin
                        hakkınızda kişisel bir pazarlama hizmeti sağlayarak “ en iyi ürün” prensibi ile hizmet sağlamak,
                        otomatik sistemler aracılığı ile kişisel alışveriş alışkanlıklarınız hakkında analiz yapma ve iş
                        ortakları, tedarikçileri, servis sağlayıcıları tarafından da kullanılmak üzere,
                        aldığınız/ilgilendiğiniz ürünler ve ilgili müşteri hizmetleri, tüketici hakları ve diğer
                        imkânlardan istifade edebilmeniz ve/veya bunlarla ilgili ticari/mali/hukuki sorumlulukların
                        yerine getirilebilmesi ve/veya temel hak ve özgürlüklerinize zarar vermemek kaydı ile hukuken
                        meşru menfaatler için gereken veya zorunlu olan durumlarda işlenebilecektir. Tüm bu faaliyet,
                        amaç ve yasal yükümlülüklerimizi yerine getirebilmeyi sağlayacak Kişisel Verileriniz, açık
                        rızanıza istinaden veya tabi olduğumuz yasal mevzuat başta olmak üzere KVKK md. 5/f.2’de
                        öngörülen diğer hallerde, işbu Kişisel Verilerin Korunması Hakkında Bilgilendirme metni ile
                        belirlenen amaçlar ve kapsam dışında kullanılmamak kaydı ile Veri Sorumlusu sıfatıyla
                        tarafımızca işlenmekte ve saklanmaktadır&nbsp;</p>
                      <p><strong>KİŞİSEL VERİLERİN AKTARILMASI&nbsp;</strong></p>
                      <p>Toplanan kişisel verileriniz; ARKMAN tarafından sunulan ürün ve hizmetlerden sizleri
                        faydalandırmak için gerekli çalışmaların iş birimlerimiz tarafından yapılması ARKMAN tarafından
                        sunulan ürün ve hizmetlerin sizlerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre
                        özelleştirilerek sizlere önerilmesi, ARKMAN ve ARKMAN ile iş ilişkisi içerisinde olan kişilerin
                        hukuki ve ticari güvenliğinin temini (Şirketimiz tarafından yürütülen iletişime yönelik idari
                        operasyonlar, ARKMAN’a ait lokasyonların fiziksel güvenliğini ve denetimini sağlamak, iş
                        ortağı/müşteri/tedarikçi (yetkili veya çalışanları) değerlendirme süreçleri, itibar araştırma
                        süreçleri, hukuki uyum süreci, denetim, mali işler v.b.), ARKMAN ticari ve iş stratejilerinin
                        belirlenmesi ve uygulanması ile ARKMAN insan kaynakları politikalarının yürütülmesinin temini
                        amaçlarıyla iş ortaklarımıza, tedarikçilerimize kanunen yetkili kamu kurumları ve özel kişilere,
                        KVK Kanunu’nun 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları
                        çerçevesinde aktarılabilecektir.&nbsp;</p>
                      <p><strong>KİŞİSEL VERİ SAHİBİNİN HAKLARI&nbsp;</strong></p>
                      <p>Kişisel veri sahipleri olarak, haklarınıza ilişkin taleplerinizi, ARKMAN ‘a iletebilirsiniz. Bu
                        kapsamda kişisel veri sahipleri;</p>
                      <ol>
                        <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                        <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
                          öğrenme,</li>
                        <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                        <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme
                          ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
                          isteme,</li>
                        <li>KVK Kanunu’nun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen,
                          işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya
                          yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü
                          kişilere bildirilmesini isteme,</li>
                        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
                          kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
                        <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın
                          giderilmesini talep etme haklarına sahiptir.</li>
                      </ol>
                      <p>Yukarıda belirtilen haklarınızı kullanmak için kimliğinizi tespit edici gerekli bilgiler ile
                        KVK Kanunu’nun 11. maddesinde belirtilen haklardan kullanmayı talep ettiğiniz hakkınıza yönelik
                        açıklamalarınızı içeren başvurunuzu Eğitim Mahallesi Ahsen Çıkmazı Sadıkoğlu İş Merkezi 1 Bina
                        No:10 Daire No:50 Kadıköy, İstanbul adresine kimliğinizi tespit edici belgeler ile iadeli
                        taahhütlü posta &nbsp;kanalıyla veya KVK Kanunu’nda belirtilen diğer yöntemler ile
                        gönderebilirsiniz.&nbsp;</p>

                    </div>

                  </v-flex>
                </v-card>
              </div>
            </v-flex>

          </v-layout>

        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="sozlesmeIptal()">{{ $t('OK') }}</v-btn>

          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      sozlesmeKabul() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramssozlesme = {
          ID: null,
          SozlesmeID: this.mesaj.SozlesmeID,
          UserID: credentials.UserID,
          ConfirmDate: helpers.getDateTimeNow(),
        }

        this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractConfirm', paramssozlesme, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
            'CoperSirketNo': credentials.CoperSirketNo.toString(),
            'MusteriKodu': credentials.AnaSirketKodu.toString()
          }
        }).then((response) => {

          if (response.body.Status == true) {
            this.resolve(true);
            this.dialogyetki = false

          } else {

          }

          this.text1 = response.body.ResponseMessage;
          this.snackbar = true

        }, (response) => {
          this.text1 = 'Service Unavailable'
          this.snackbar = true


        })
      },
      sozlesmeIptal() {
        this.resolve(false);
        this.dialogyetki = false
      },


      open(mesaj) {
        //this.mesaj = mesaj
        // this.mesaj.SozlesmeText = this.mesaj.SozlesmeText

        this.dialogyetki = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        bekle: false,
        islem: 0,
        sozlesmeOnay: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        k: null,
        doviztipi: [],
        reject: null,
        tahsilatdialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>
<style>
  header {
    font-family: 'Lobster', cursive;
    text-align: center;
    font-size: 25px;
  }

  #info {
    font-size: 18px;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    color: #074E8C;
  }

  .scrollbar {
    margin-left: 10px;
    float: left;
    height: 300px;
    width: 100%px;
    background: rgb(255, 255, 255);
    overflow-y: scroll;
    margin-bottom: 25px;
  }

  .force-overflow {
    min-width: 800px;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: royalblue;
  }
</style>